<div class="row" *ngFor="let marker of markers; let i = index;">
  <div class="col">
    <sb-card>
      <div card-body>
        <div class="row">
          <div class="col-md-5">
            <h5 class="mb-2">{{ 'lang.channels.markerInformation' | translate }}</h5>
            <div class="text-muted">ID: {{ marker?.id ?? '-' }}</div>
            <div class="text-muted">{{ '#' + (i + 1) }}</div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{ 'lang.channels.markerName' | translate }}</span>
            </div>
            <div class="form-group">
              <input class="form-control"
                     [disabled]="channel?.locked || !permissionService.hasPermission(permissionService.Permission.channel_edit)"
                     [(ngModel)]="marker.name" (ngModelChange)="emitChange()" type="text"/>
            </div>
            <h5 class="mb-2">{{ 'lang.globals.resolution' | translate }}</h5>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{ 'lang.globals.width' | translate }}</span>
            </div>
            <div class="form-group">
              <input class="form-control"
                     [disabled]="channel?.locked || !permissionService.hasPermission(permissionService.Permission.channel_edit)"
                     [(ngModel)]="marker.resolution.width" (ngModelChange)="emitChange()" type="number"/>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="text-dark-75 font-weight-bolder">{{ 'lang.globals.height' | translate }}</span>
            </div>
            <div class="form-group">
              <input class="form-control"
                     [disabled]="channel?.locked || !permissionService.hasPermission(permissionService.Permission.channel_edit)"
                     [(ngModel)]="marker.resolution.height" (ngModelChange)="emitChange()" type="number"/>
            </div>
            <div class="form-group" *ngIf="!channel?.locked && permissionService.hasPermission(permissionService.Permission.channel_edit)">
              <sb-button classes="btn-danger m-0" (click)="removeMarker(i)">
                <sb-icon [icon]="'trash'"></sb-icon>&nbsp;<span
                class="d-none d-sm-inline-block"> {{ 'lang.channels.removeMarker' | translate }}</span>
              </sb-button>
            </div>
          </div>
          <div class="col-md-7">
            <div class="row">
              <div class="col">
                <div class="screenborder">
                  <div class="d-flex justify-content-center align-items-center screencontent"
                       [style.backgroundImage]="getPreviewBackgroundImageByIndex(i)"
                       [style.backgroundColor]="getPreviewBackgroundColorByIndex(i)"
                       [style.height.px]="calculateHeight(marker)" [style.width.px]="calculateWidth(marker)">
                    <h3 style="color: #fdfeff" class="resolution-text">
                      {{ marker?.resolution?.width }}x{{ marker?.resolution?.height }}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <div class="ml-2 d-flex justify-content-right align-items-center">
                  <div class="previewselect blue-bg mr-3" (click)="selectPreview(i, -1)">
                  </div>
                  <ng-container *ngFor="let preview of previews; let iprev = index;">
                    <div class="previewselect mr-3" (click)="selectPreview(i, iprev)"
                         [style.backgroundImage]="preview?'url(' + preview + ')':''">
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>
<div class="row" *ngIf="!channel?.locked && permissionService.hasPermission(permissionService.Permission.channel_edit)">
  <div class="col">
    <sb-card>
      <div card-body>
        <sb-button classes="btn-success m-0" (click)="addMarker()">
          <sb-icon [icon]="'plus'"></sb-icon>&nbsp;<span
          class="d-none d-sm-inline-block"> {{ 'lang.channels.addMarker' | translate }}</span>
        </sb-button>
      </div>
    </sb-card>
  </div>
</div>
